import { render, staticRenderFns } from "./MimecastDataCapture.vue?vue&type=template&id=21a9dfda&scoped=true&"
import script from "./MimecastDataCapture.vue?vue&type=script&lang=js&"
export * from "./MimecastDataCapture.vue?vue&type=script&lang=js&"
import style0 from "./MimecastDataCapture.vue?vue&type=style&index=0&id=21a9dfda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9dfda",
  null
  
)

export default component.exports